export default __webpack_public_path__ + "static/media/art_image1.310100e0.jpg";